export default __webpack_public_path__ + "img/img02.e88b2c7d.png";